import { render, staticRenderFns } from "./ReviewFilter.vue?vue&type=template&id=ed3e16c6"
import script from "./ReviewFilter.vue?vue&type=script&lang=js"
export * from "./ReviewFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports